import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import ContentWrapper from '../components/content-wrapper';
import { LargePrimaryButton } from '../components/button';
import TitledComponent from '../components/titled-component';
import { InlineInput } from '../components/inline-input';
import { connect } from 'react-redux';
import { redirectAction } from '../actions/redirect';
import { Field, formValueSelector, propTypes, reduxForm, } from 'redux-form';
import {
  heightWeightNormalizer, heightWeightValidator,
  nameNormalizer,
  required,
} from '../validator';
import { MEDICAL_HISTORY_FORM_NAME } from './medical-history';
import { requestUpdateUserInfo } from '../actions/user';

const FlexWrapper = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
`;

const Stretcher = styled.div`
  background: #f2f2f2;
  min-height: 88px;
  flex-grow: 1;
`;

class _UpdateInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateModalOpen: false,
      lastDate: null,
    };
  }

  render() {
    const {
      handleSubmit, pristine, submitting, invalid, medicalHistoryVisited
    } = this.props;

    return (
      <form onSubmit={handleSubmit} style={{ height: '100%' }}>
        <FlexWrapper>
          <InlineInput label='姓名'>
            <Field
              name='name'
              normalize={nameNormalizer}
              validate={required}
              component={InlineInput.Input}
              type='text' />
          </InlineInput>
          <Field
            name='birthday'
            validate={required}
            setState={(s, cb) => this.setState(s, cb)}
            lastDate={this.state.lastDate}
            dateModalOpen={this.state.dateModalOpen}
            component={props => InlineInput.DateField(props)} />
          <Field name='gender' validate={required} component={InlineInput.RadioField} />
          <InlineInput label='身高 (厘米)'>
            <Field
              name='height'
              normalize={heightWeightNormalizer}
              validate={heightWeightValidator}
              component={InlineInput.Input}
              type='number'
              pattern='\d*' />
          </InlineInput>
          <InlineInput label='体重 (公斤)'>
            <Field
              name='weight'
              normalize={heightWeightNormalizer}
              validate={heightWeightValidator}
              component={InlineInput.Input}
              type='number'
              pattern='\d*' />
          </InlineInput>
          <InlineInput label='有无病史' onClick={() => this.props.dispatch(redirectAction('/medicalhistory'))}>
            <InlineInput.More>
              {medicalHistoryVisited ? ' >' : '请选择 >'}
            </InlineInput.More>
          </InlineInput>
          <Stretcher />
          <LargePrimaryButton
            disabled={invalid || (pristine && !medicalHistoryVisited) || submitting}
            style={{
            width: '100%',
            margin: '0',
          }}>
            保存
          </LargePrimaryButton>
        </FlexWrapper>
      </form>
    );
  }
}

_UpdateInfoForm.defaultProps = {
  medicalHistoryVisited: false,
};

_UpdateInfoForm.propTypes = {
  ...propTypes,
  medicalHistoryVisited: PropTypes.bool,
};

export const UPDATE_INFO_FORM_NAME = 'update_info';

const UpdateInfoForm = connect(({ user: { me } }) => ({
  initialValues: {
    name: me.name,
    gender: me.gender,
    birthday: me.birthday,
    height: me.height,
    weight: me.weight,
  }
}))(reduxForm({
  form: UPDATE_INFO_FORM_NAME, // a unique name for this form
  destroyOnUnmount: false,
})(_UpdateInfoForm));


class UpdateInfo extends TitledComponent {
  onSubmit(e) {
    const { me: { medical_history: medicalHistory } } = this.props;
    this.props.dispatch(requestUpdateUserInfo({
      ...e,
      medical_history: [...(this.props.medicalHistory || medicalHistory)],
    }));
  }

  render() {
    return (
      <UpdateInfoForm
        onSubmit={e => this.onSubmit(e)}
        dispatch={this.props.dispatch}
        medicalHistoryVisited={typeof this.props.medicalHistory !== 'undefined'}
      />
    );
  }
}

UpdateInfo.defaultProps = {
  title: '修改个人信息',
};

const selector = formValueSelector(MEDICAL_HISTORY_FORM_NAME);

export default connect(state => ({
  me: state.user.me,
  medicalHistory: selector(state, 'selected'),
}))(UpdateInfo);



// WEBPACK FOOTER //
// ./src/scene/update-info.jsx